import { useEffect } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useCurrentWorkspace } from "@/hooks/useCurrentWorkspace";
import { useWorkflowById } from "@/queries/workflowQueries";
import LoadingScreen from "@/components/LoadingScreen";

export function WorkpaceIdWorkflowIdRedirect() {
    const { workspaceId, workflowId } = useParams<{ workspaceId: string; workflowId: string }>();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const step = searchParams.get("step") || "deploy";

    const { currentWorkspace, switchWorkspace } = useCurrentWorkspace();

    useEffect(() => {
        if (workspaceId) {
            switchWorkspace(workspaceId);
        }
    }, [workspaceId, switchWorkspace]);

    const { data: fetchedWorkflow, error: queryError } = useWorkflowById(workflowId);

    useEffect(() => {
        if (currentWorkspace && fetchedWorkflow?.url) {
            navigate(`/${currentWorkspace.url}/${fetchedWorkflow.url}/${step}`, { replace: true });
        }
    }, [currentWorkspace, fetchedWorkflow, navigate, step]);

    useEffect(() => {
        if (queryError) {
            console.error("🐞[DEBUG - WorkpaceIdWorkflowIdRedirect] error", queryError);
            navigate("/");
        }
    }, [queryError, navigate]);

    return <LoadingScreen />;
}
